module.exports = "## Crop, flip, or rotate images\r\n\r\nSometimes your photo compositions don’t come out the way you want them. Our Image Editor let you get rid of unwanted areas in your photos using the Photo Cropper.\r\n\r\nYou can also apply an aspect ratio to your crop to make sure your photo perfectly fit social media sites and display devices without having to stretch.\r\n\r\nYou can also flip or rotate your images."


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoEditor/photo-editor-section-three.md
// module id = 1170
// module chunks = 0